import ReserveForm from "../ReserveForm";

function ReserveTablePage() {

    return (
        <>
            <section className="testimonialArea">
                <ReserveForm />
            </section>
        </>
    );
}

export default ReserveTablePage;